import { JourneyCallApiModel } from './journey-call.api-model';
import type { IJourneyPrognosis } from './journey-prognosis.model';

export class JourneyPrognosisApiModel {
  serviceJourneyGid!: string;
  delayInMinutes!: number | null;
  cancelled!: boolean;
  timetableOnly!: boolean;
  updatedAt!: string;
  calls!: JourneyCallApiModel[];

  public static mapToBusinessModel(model: JourneyPrognosisApiModel): IJourneyPrognosis {
    return {
      ...model,
      calls: model.calls.map(JourneyCallApiModel.mapToBusinessModel),
    };
  }
}
